import { render, staticRenderFns } from "./SearchAndResult.vue?vue&type=template&id=3c5f70f7&scoped=true&"
import script from "./SearchAndResult.vue?vue&type=script&lang=js&"
export * from "./SearchAndResult.vue?vue&type=script&lang=js&"
import style0 from "./SearchAndResult.vue?vue&type=style&index=0&id=3c5f70f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f70f7",
  null
  
)

export default component.exports